import React, { FC } from 'react';
import { StepSection } from '../../../components/StepPanel';

interface ConsentsProps {
  isAgreedThePrivacyPolicy: boolean;
  // eslint-disable-next-line no-unused-vars
  setIsAgreedThePrivacyPolicy: (value: boolean) => void;
}

const Consents: FC<ConsentsProps> = ({
  isAgreedThePrivacyPolicy, setIsAgreedThePrivacyPolicy,
}) => (
  <StepSection>
    <h3>Privacy</h3>
    <label id="privacy-consent" className={`ck-inline${isAgreedThePrivacyPolicy ? ' on' : ''}`} htmlFor="privacy-consent-input">
      <input
        id="privacy-consent-input"
        type="checkbox"
        checked={isAgreedThePrivacyPolicy}
        onChange={(e) => setIsAgreedThePrivacyPolicy(e.target.checked)}
      />
      <span className="tx">
        <b>
          {'I have read Telecare\'s '}
          <a target="_blank" rel="noreferrer" href="https://www.telecare.com.au/privacy-policy">Privacy Policy</a>
        </b>
        <span>
          I understand the information in this form will be accessed by Telecare&apos;s practice management and reception team, and by Telecare&apos;s clinicians so I receive optimal care.
        </span>
      </span>
    </label>
  </StepSection>
);

export default Consents;
